import { TableFilters } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

import type { FilterBaseProps } from '@circlefin/components/lib/TableFilters/types'

export type NicknameProps = Omit<FilterBaseProps, 'name'>

/**
 * Search Nickname.
 */
export const Nickname: React.FC<NicknameProps> = (props) => {
  const { t } = useTranslation('address-book/filters')

  return (
    <TableFilters.Input
      {...props}
      alignIcon="right"
      icon="SearchOutline"
      name="nickname"
      placeholder={t`table.nickname`}
    />
  )
}
